import { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#2563eb', // 更现代的蓝色
    borderRadius: 12, // 更圆润的边框
    colorLink: '#2563eb',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', // 更轻量的阴影
  },
  components: {
    Layout: {
      headerBg: 'rgba(255, 255, 255, 0.8)', // 磨砂玻璃效果背景
      bodyBg: '#f8fafc', // 更清爽的背景色
      siderBg: '#0f172a', // 深靛蓝色侧边栏，更专业
    },
    Menu: {
      darkItemBg: '#0f172a',
      darkItemSelectedBg: '#1e293b',
      itemHeight: 50,
      itemMarginInline: 12,
      itemBorderRadius: 8,
    },
    Card: {
      boxShadowTertiary: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    },
    Button: {
      fontWeight: 500,
      controlHeight: 36,
    },
  },
};
